import {AddRefRewardForm} from "@components/consumer/refs";
import withPage from "@components/hoc/withPage";
import {FC, useCallback} from "react";
import {useParams} from "react-router";
import ConsumerRefService from "@api/consumer/consumerRefService";
import {useBreadcrumbs} from "@services/hooks";
import {useStateLoader} from "@hooks/panelHooks";

const AddRefRewardPage: FC = () => {

    const {ref_id} = useParams<{ ref_id: string }>();
    const loadRef = useCallback((ref_id: string) => {
        const api = new ConsumerRefService();
        return api.getRef(ref_id);
    }, []);

    const {data: ref} = useStateLoader(loadRef, ref_id);
    useBreadcrumbs('consumer.refs.current.name', true, ref?.name, `/consumer/refs/${ref_id}/`);
    useBreadcrumbs('consumer.refs.rewards', true, null, `/consumer/refs/${ref_id}/rewards/`);

    return <AddRefRewardForm />
}

export default withPage(AddRefRewardPage);
